<script>

export default {
  name: 'password-criteria',
  computed: {
    criteriaPass() {
      return Object.values(this.hint).filter(result => !result).length < 1;
    },
  },
  data() {
    return {
      showHintGroup: false,
      hint: {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      },
      passwordHintMessages: {
        lc: '1 letra minuscula', // 1 lowercase letter
        uc: '1 letra mayúscula', // 1 uppercase letter
        num: '1 numero', // 1 number
        len: 'al menos 8 caracteres', // at least 8 characters
        sym: '1 símbolo !@#$%^&*_-', // 1 symbol !@#$%^&*_-
      },
    };
  },
  methods: {
    showHint() {
      if (!this.showHintGroup) {
        this.showHintGroup = true;
      }
      const lc = /^(?=.*[a-z]).+$/;
      const uc = /^(?=.*[A-Z]).+$/; // uppercase letter
      const num = /^(?=.*\d).+$/; // a number
      const sym = /^(?=.*[!@#$%^&*_-]).+$/; // symbol
      const len = /^.{7,}.+$/; // at least 8 chars
      // check lowercase letter
      const { value } = this.validations.newPassword;
      this.hint.lc = lc.test(value);
      // check uppercase letter
      this.hint.uc = uc.test(value);
      // check for a number
      this.hint.num = num.test(value);
      // check for symbol
      this.hint.sym = sym.test(value);
      // check password length
      this.hint.len = len.test(value);
    },
    resetHint() {
      this.showHintGroup = false;
      this.hint = {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      };
    },
  },
};
</script>

<style lang="scss">
.lcu-passHint-group {
  background-color: $gray-lightest;
  color: $gray-dark;
  border: 1px solid $page-border;
  padding: 10px;
}

.lcu-hintPass {

  &:before {
    color: $danger;
    content: '\e811';
    display: inline-block;
    font-family: 'lcu';
    font-size: 9pt;
    margin-right: 3px;
  }
}

.lcu-hintPass-good {

  &:before {
    color: $success;
    content: '\e820';
  }
}
</style>
